import { render } from "./SecondOpinionRequestView.vue?vue&type=template&id=8ebf2ace&scoped=true&ts=true"
import script from "./SecondOpinionRequestView.vue?vue&type=script&lang=ts"
export * from "./SecondOpinionRequestView.vue?vue&type=script&lang=ts"

import "./SecondOpinionRequestView.vue?vue&type=style&index=0&id=8ebf2ace&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ebf2ace"]])

export default __exports__